import { Button, ButtonProps } from 'react-admin';

export const StyledButton = ({ sx, ...props }: ButtonProps) => {

  return (
    <Button
      variant={'contained'}
      color={'secondary'}
      size={'small'}
      {...props}
      sx={[{ whiteSpace: 'nowrap' }, ...(Array.isArray(sx) ? sx : [sx])]}
    />
  );

};
